import React, { useEffect } from "react";
import { Box, Text } from "@chakra-ui/react";
import {
  ARCHIVE_BANNER_MESSAGE,
  ARCHIVE_MODE_ENABLED,
} from "./archiveConfig";

const bodyPadding = "56px";

export default function ArchiveBanner() {
  useEffect(() => {
    if (!ARCHIVE_MODE_ENABLED) {
      return undefined;
    }

    const previousPaddingTop = document.body.style.paddingTop;
    document.body.style.paddingTop = bodyPadding;

    return () => {
      document.body.style.paddingTop = previousPaddingTop;
    };
  }, []);

  if (!ARCHIVE_MODE_ENABLED) {
    return null;
  }

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      zIndex="2000"
      bg="#7a2e0b"
      color="white"
      px={4}
      py={3}
      boxShadow="0 6px 18px rgba(0, 0, 0, 0.18)"
    >
      <Text fontSize={{ base: "xs", md: "sm" }} fontWeight="600" textAlign="center">
        {ARCHIVE_BANNER_MESSAGE}
      </Text>
    </Box>
  );
}
